module.exports = __webpack_public_path__ + "img/1.53aa8410.png";